// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 648) return "static/chunks/648-eca7658df95bde09.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"f2ad0b204f56ec50","298":"3c17f9a45cf5b456","340":"04b2c4c72884fd55","367":"f2dff64e0747f8d1","639":"662b2e7c337118a6","748":"071deb8a8090adeb"}[chunkId] + ".js";
};